"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var Collections = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M7.78021227,19.7611256 C7.28638452,20.0084161 6.68558946,19.8085582 6.43829895,19.3147304 L2.40846716,11.2673423 C2.16117664,10.7735145 2.36103456,10.1727195 2.85486231,9.92542896 L8,7.34893593 L8,7 C8,6.44771525 8.44771525,6 9,6 L15,6 C15.5522847,6 16,6.44771525 16,7 L16,7.34893593 L21.1462548,9.92598835 C21.6396461,10.1730603 21.839664,10.7730838 21.5932097,11.2667839 L17.8367221,18.7918018 C17.590047,19.2859372 16.9895022,19.486546 16.4953654,19.2398738 L12.6512189,17.3148686 C11.8346391,17.7266847 10.2109703,18.5421037 7.78021227,19.7611256 Z M16.9420067,18.3451598 L20.6984971,10.8201433 L16,8.46731121 L16,16 C16,16.5522847 15.5522847,17 15,17 L14.2557847,17 L16.9420067,18.3451598 Z M15,16 L15,7 L9,7 L9,7.18990787 C9.23579741,7.2729979 9.44091635,7.44406811 9.56170105,7.68526958 C12.2969324,13.1679238 13.6701096,15.9395006 13.6812327,16 L15,16 Z M3.30262139,10.8195832 L7.33245318,18.8669713 L12.6973786,16.1804168 L8.66754682,8.13302867 L3.30262139,10.8195832 Z" })));
};
Collections.displayName = 'Collections';
exports.default = Collections;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Collections.js.map